import React from 'react';

export const IconFacebook = () => {
    return (
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="73 4.5 267 240">
            <path d="M255.4,262.3v-99.8h33.5l5-38.9h-38.5V98.8c0-11.3,3.1-18.9,19.3-18.9l20.6,0V45 c-3.6-0.5-15.8-1.5-30-1.5c-29.7,0-50,18.1-50,51.4v28.7h-33.6v38.9h33.6v99.8H255.4z"/>
        </svg>
    )
}
